import { RolePermissionObjects } from './rolePermissionObjects.constants';

interface AiAnalystAdminTab {
    routerLink: string;
    title: string;
    objectId?: string;
    superAdminOnly?: boolean;
    requiresAnalystEnabled?: boolean;
    requiresReferenceLibrary?: boolean;
}

const aiAnalystAdminTabs: AiAnalystAdminTab[] = [
    { routerLink: '/dashboard/ai-analyst-admin/usage-by-user', title: 'Usage by user', objectId: RolePermissionObjects.AiUsageRecord, requiresAnalystEnabled: true },
    { routerLink: '/dashboard/ai-analyst-admin/balances', title: 'Balances', objectId: RolePermissionObjects.SiteCreditBalance, requiresAnalystEnabled: true },
    { routerLink: '/dashboard/ai-analyst-admin/success-metrics', title: 'Success Metrics', superAdminOnly: true },
    { routerLink: '/dashboard/ai-analyst-admin/enablement', title: 'Enablement', superAdminOnly: true },
    { routerLink: '/dashboard/ai-analyst-admin/reference-library', title: 'Reference library', requiresReferenceLibrary: true },
];

export const getAiAnalystAdminRouteConfig = (
    isSuperAdmin: boolean,
    isAnalystEnabled = true,
    canReadReferenceLibrary = false,
): { routerLink: string; title: string; objectId?: string }[] =>
    aiAnalystAdminTabs
        .filter(tab => isSuperAdmin || !tab.superAdminOnly)
        .filter(tab => isAnalystEnabled || !tab.requiresAnalystEnabled)
        .filter(tab => canReadReferenceLibrary || !tab.requiresReferenceLibrary)
        .map(({ routerLink, title, objectId }) => ({ routerLink, title, objectId }));

export const findFirstReadableAiAnalystAdminTab = <T extends { objectId?: string }>(
    tabs: T[],
    hasReadPermission: (objectId: string) => boolean,
): T | undefined =>
    tabs.find(tab => !tab.objectId || hasReadPermission(tab.objectId));
